import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-disabled',
  templateUrl: './account-disabled.component.html',
  styleUrls: ['./account-disabled.component.scss']
})
export class AccountDisabledComponent {

  constructor(
    private router: Router
  ) {}


  goToSettings(){
     this.router.navigate(['/dashboard/settings']);
  }
}

